module.exports = __webpack_public_path__ + "static/img/live-1536.a86a496.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ie/live-1536.png
// module id = XD2t
// module chunks = 3